import { render, staticRenderFns } from "./InviteeGroupSecurity.vue?vue&type=template&id=64a4b4c8"
import script from "./InviteeGroupSecurity.vue?vue&type=script&lang=js"
export * from "./InviteeGroupSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports